import Profile from "./Profile";
import HeaderCommon from "./HeaderCommon";
import { Link } from "react-router-dom";

function HeaderPracticeQuestions() {
    return (
        <header>
            <div className="d-flex align-items-center justify-content-between px-4 py-2 main-header">
                <HeaderCommon />
                <div className="d-flex align-items-center">
                    <Link
                        className="btn btn-green3 bg-blue1 border-0 px-2 me-2"
                        to="/torso"
                    >
                        <img
                            src="/images/menu/torso.png"
                            alt="torso"
                            style={{ width: "1.5rem" }}
                        />
                    </Link>
                    <Profile />
                </div>
            </div>
        </header>
    );
}

export default HeaderPracticeQuestions;
